import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '../services/data/data.service';
import { environment } from 'environments/environment';

@Directive({
  selector: '[appChangeColorTheme]'
})
export class ChangeColorThemeDirective implements AfterViewInit, OnDestroy {

  @Input() attribute: string;
  @Input() rgba: string;
  @Input() borderPx: string;
  @Input() isHover = false;


  // colorBase = '#0069b6';
  colorBase = '#131c47';
  colorBaseRGBA = '0, 105, 182';
  colorDemo = '#4fb140';
  colorDemoRGBA = '79, 177, 64';
  colorQual = '#D73737';
  colorQualRGBA = '215, 55, 55';

  subscription: Subscription = new Subscription();
  isDemo: boolean;

  constructor(
    private el: ElementRef,
    private dataService: DataService
  ) {
  }

  @HostListener('mouseenter')
  onEnter() {

    if (this.isHover) {
      this.el.nativeElement.children[0].style.color = '#fff';
      this.isDemo ?
        (this.el.nativeElement.style.color = '#fff !important', this.el.nativeElement.style.backgroundColor = this.colorDemo) :
        (this.el.nativeElement.style.color = '#fff !important', this.el.nativeElement.style.backgroundColor = this.colorBase);
    }

  }
  @HostListener('mouseleave')
  onLeave() {
    if (this.isHover) {
      this.el.nativeElement.children[0].style.color = '#fff';
      this.isDemo ?
        (this.el.nativeElement.children[0].style.color = this.colorDemo) :
        (this.el.nativeElement.children[0].style.color = this.colorBase);
      this.el.nativeElement.style.backgroundColor = 'transparent';
    }

  }

  ngAfterViewInit(): void {
    // if (environment.name === 'qual') {
    //   this.colorBase = this.colorQual;
    //   this.colorDemo = this.colorQual;
    //   this.colorBaseRGBA = this.colorQualRGBA;
    //   this.colorDemoRGBA = this.colorQualRGBA;
    // }
    // this.initSub();
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.themeDemo$.subscribe({
        next: isDemo => {
          // this.rgba = this.rgba === undefined ? '1' : this.rgba;
          console.log('this.attribute : ', this.attribute);
          this.isDemo = isDemo;

          switch (this.attribute) {
            case 'color':

              if (+this.rgba < 1) {
                isDemo ?
                  this.el.nativeElement.style.color = 'rgba(' + this.colorDemoRGBA + ',' + this.rgba + ')' :
                  this.el.nativeElement.style.color = 'rgba(' + this.colorBaseRGBA + ',' + this.rgba + ')';

              } else {
                isDemo ?
                  this.el.nativeElement.style.color = this.colorDemo :
                  this.el.nativeElement.style.color = this.colorBase;
              }

              break;
            case 'bgc':
              if (+this.rgba < 1) {
                isDemo ?
                  this.el.nativeElement.style.backgroundColor = 'rgba(' + this.colorDemoRGBA + ',' + this.rgba + ')' :
                  this.el.nativeElement.style.backgroundColor = 'rgba(' + this.colorBaseRGBA + ',' + this.rgba + ')';

              } else {
                isDemo ?
                  this.el.nativeElement.style.backgroundColor = this.colorDemo :
                  this.el.nativeElement.style.backgroundColor = this.colorBase;
              }
              break;

            case 'border':
              if (+this.rgba < 1) {
                isDemo ?
                  this.el.nativeElement.style.border = this.borderPx + ' solid ' + 'rgba(' + this.colorDemoRGBA + ',' + this.rgba + ')' :
                  this.el.nativeElement.style.border = this.borderPx + ' solid ' + 'rgba(' + this.colorBaseRGBA + ',' + this.rgba + ')';

              } else {
                isDemo ?
                  this.el.nativeElement.style.border = this.borderPx + ' solid ' + this.colorDemo :
                  this.el.nativeElement.style.border = this.borderPx + ' solid ' + this.colorBase;
              }
              break;

            default:
              break;
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
